

import { useCallback } from 'react';
import _get from 'lodash.get';
import _set from 'lodash.set';
import _cloneDeep from 'lodash.clonedeep';
import { useAsync } from '../useAsync/useAsync';
import { replaceBucketKeys as replaceBucketKeysUtil } from '../useWithResolvedBucketKeys/utils';




async function replaceBucketKeys(
data, {
  apolloClient,
  organisationId,
  substitutedKeys,
  dataPath,
  getOrganisationId
})
{
  const dataArray = dataPath ? _get(data, dataPath) : data;

  if (!dataArray || dataArray.length === 0) {
    return data;
  }

  const replacedData = await replaceBucketKeysUtil({
    apiClient: apolloClient,
    data: dataArray,
    substitutedKeys,
    organisationId,
    getOrganisationId
  });

  if (dataPath) {
    const newData = _cloneDeep(data);
    return _set(newData, dataPath, replacedData);
  }

  return replacedData;
}

export function useApi(
{
  fn,
  dataBasePath,
  replaceBucketKeysOptions,
  ...useAsyncOptions
},
deps = [])
{
  const apiFn = useCallback(async () => {
    const response = await fn();
    let newData = response;

    if (!response) {
      return newData;
    }

    const { data, error } = response;

    if (error) {
      throw error;
    }

    newData = data && _get(data, dataBasePath);

    if (replaceBucketKeysOptions && newData) {
      newData = await replaceBucketKeys(newData, replaceBucketKeysOptions);
    }

    return newData;
  }, deps);

  return useAsync({
    fn: apiFn,
    ...useAsyncOptions
  }, [apiFn]);
}